import {
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START,
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED,
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED,
  FETCH_SHARED_WORKOUT_PREVIEW_START,
  FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED,
  FETCH_SHARED_WORKOUT_PREVIEW_REJECTED,
  SET_ACTIVE_SHARED_WORKOUT_MODAL,
  SET_IS_DOWNLOAD_BUTTON_CLICKED,
  DOWNLOAD_SHARED_WORKOUT_START,
  DOWNLOAD_SHARED_WORKOUT_FULFILLED,
  DOWNLOAD_SHARED_WORKOUT_REJECTED,
} from './actionTypes';

import {
  SUBMIT_LOGIN_FULFILLED,
} from '../../login/ducks/actionTypes';

const initialState = {
  activeModal: '',
  isDownloadButtonClicked: false,
  isDownloading: false,
  isDownloadComplete: false,
  downloadPending: false,
  isLoadingProgram: false,
  isLoadingWorkout: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START: {
      return {
        ...state,
        isLoadingProgram: true,
      };
    }
    case FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED: {
      return {
        ...state,
        isLoadingProgram: false,
      };
    }
    case FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED: {
      return {
        ...state,
        isLoadingProgram: false,
      };
    }
    case FETCH_SHARED_WORKOUT_PREVIEW_START: {
      return {
        ...state,
        isLoadingWorkout: true,
      };
    }
    case FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED: {
      return {
        ...state,
        isLoadingWorkout: false,
      };
    }
    case FETCH_SHARED_WORKOUT_PREVIEW_REJECTED: {
      return {
        ...state,
        isLoadingWorkout: false,
      };
    }
    case SET_ACTIVE_SHARED_WORKOUT_MODAL: {
      // Opening or closing the modal starts the download UI fresh, so a prior
      // completion never lingers into a re-open or a different program.
      return {
        ...state,
        activeModal: action.payload.activeModal,
        isDownloading: false,
        isDownloadComplete: false,
        downloadPending: false,
      };
    }
    case SUBMIT_LOGIN_FULFILLED: {
      return {
        ...state,
        activeModal: 'download',
      };
    }
    case SET_IS_DOWNLOAD_BUTTON_CLICKED: {
      return {
        ...state,
        isDownloadButtonClicked: action.payload.bool,
      };
    }
    case DOWNLOAD_SHARED_WORKOUT_START: {
      return {
        ...state,
        isDownloading: true,
        isDownloadComplete: false,
        downloadPending: false,
      };
    }
    case DOWNLOAD_SHARED_WORKOUT_FULFILLED: {
      return {
        ...state,
        isDownloading: false,
        isDownloadComplete: true,
        downloadPending: action.payload.pending,
      };
    }
    case DOWNLOAD_SHARED_WORKOUT_REJECTED: {
      return {
        ...state,
        isDownloading: false,
        isDownloadComplete: false,
        downloadPending: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
